<h2 mat-dialog-title>Gestion des photos - {{ field().name }}</h2>
<mat-dialog-content>
  <div class="photos-container" [class.dragging]="isDragging()" (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
    <mat-progress-bar mode="indeterminate" *ngIf="isUploading()" class="upload-progress"></mat-progress-bar>
    <div class="photos-actions" [class.disabled-actions]="isUploading()" *ngIf="!isReadonly()">
      <!-- ... (garder le même contenu interne mais afficher seulement si !isReadonly) -->
      <!-- Input pour la galerie ou upload classique -->
      <input type="file" accept="image/jpeg,image/png,image/gif,image/bmp,image/tiff" multiple hidden #fileInput (change)="onFilesSelected($event)" />

      @if (isMobile()) {
      <!-- Input pour l'appareil photo (capture directe) -->
      <input type="file" accept="image/jpeg,image/png,image/gif,image/bmp,image/tiff" capture="environment" hidden #cameraInput
        (change)="onFilesSelected($event)" />

      <div class="action-buttons">
        <button mat-flat-button color="primary" (click)="fileInput.click()" class="action-btn">
          <mat-icon aria-hidden="true">photo_library</mat-icon>
          Galerie
        </button>
        <button mat-flat-button color="accent" (click)="cameraInput.click()" class="action-btn">
          <mat-icon aria-hidden="true">photo_camera</mat-icon>
          Appareil photo
        </button>
      </div>
      } @else {
      <button mat-flat-button color="primary" (click)="fileInput.click()">
        <mat-icon aria-hidden="true">cloud_upload</mat-icon>
        Ajouter des photos
      </button>
      }
    </div>

    <div class="photos-grid" *ngIf="field().photos?.length; else noPhotos">
      <div class="photo-card" *ngFor="let p of field().photos">
        <div class="photo-preview">
          <a *ngIf="getPhotoBlobUrl(p.id)" [href]="getPhotoBlobUrl(p.id)" target="_blank" rel="noopener noreferrer">
            <img [src]="getPhotoBlobUrl(p.id)" [alt]="p.fileName" />
          </a>
          <div *ngIf="!getPhotoBlobUrl(p.id)" class="loading-placeholder">
            <mat-icon class="loading-icon">image</mat-icon>
          </div>
        </div>
        <div class="photo-info">
          <span class="file-name" [title]="p.fileName">{{ p.fileName }}</span>
          <div class="actions">
            <button mat-icon-button title="Télécharger" (click)="downloadPhoto(p)">
              <mat-icon aria-hidden="true">download</mat-icon>
            </button>
            <button mat-icon-button color="warn" title="Supprimer" (click)="askDeletePhoto(p)" *ngIf="!isReadonly()">
              <mat-icon aria-hidden="true">delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <ng-template #noPhotos>
      <div class="no-photos">
        <mat-icon>image_not_supported</mat-icon>
        <p>Aucune photo associée à ce champ.</p>
      </div>
    </ng-template>

    <div class="error-zone" *ngIf="field().minPhotosNbr && (field().photos?.length || 0) < field().minPhotosNbr!">
      <mat-icon>error_outline</mat-icon>
      <span>Au moins {{ field().minPhotosNbr }} photo(s) requise(s)</span>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Fermer</button>
</mat-dialog-actions>

<app-confirm-dialog *ngIf="showDeleteConfirm()" [title]="'Supprimer la photo'"
  [message]="'Voulez-vous vraiment supprimer cette photo ? Cette action est irréversible.'"
  (confirmed)="confirmDeletePhoto()" (cancelled)="cancelDeletePhoto()"></app-confirm-dialog>
